import {animate, animation, keyframes, style} from "@angular/animations";

// NOTE: to avoid the "" error when running ng xi18n, hex2rgba had to be
//       rewritten to not use any variables. Fortunately, angular supports
//       hexadecimal syntax with alpha channel, e.g. #RRGGBBAA where
//       where RR=red GG=green BB=blue AA=alpha

export function hex2rgba(hex, alpha='FF') {
  return hex + alpha;
}

/**
 * create a highlight animation which wobbles the element and animates a shadow
 *
 * @param duration
 * @param delay
 * @param wobble
 * @param shadowColor
 */
export function createHighlightAnimation({ duration='0.5s',
                                           delay='300ms',
                                           wobble='5px',
                                           shadowColor= '#ccc'}) {

  /*const shadow1 = '0 0 5px 5px ' + hex2rgba(shadowColor, .8),
        shadow2 = '0 0 5px 5px ' + hex2rgba(shadowColor, .2)*/

  return animation([
    animate(duration + ' ' + delay + ' cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      keyframes([
        style({ transform: 'translate(0)', offset: 0}),
        style({ transform: 'translate(-'+wobble+')', boxShadow: '0 0 5px 5px ' + hex2rgba(shadowColor, 'CC'), offset: 0.20}),
        style({ transform: 'translate('+wobble+')', boxShadow: '0 0 5px 5px ' + hex2rgba(shadowColor, '33'), offset: 0.80}),
        style({ transform: 'translate(0)', boxShadow: 'none', offset: 1})
      ])
    )
  ])
}
